// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__UAC__"};